// Layer host – renderuje komponentu konkrétní vrstvy

import { cn } from '@/shared/lib/utils';
import type { LayerDescriptor } from '../core/layerDescriptor';

interface NavigationLayerHostProps {
  layer: LayerDescriptor;
  isInteractive: boolean;
}

/**
 * Renderuje komponentu jedné vrstvy.
 * Neinteraktivní vrstvy jsou vizuálně utlumeny a blokují pointer events.
 * Lazy vrstvy se nerenderují, dokud nejsou aktivovány.
 */
export function NavigationLayerHost({ layer, isInteractive }: NavigationLayerHostProps) {
  // Lazy vrstvy se nerenderují – aktivace proběhne až při odhalení
  if (layer.status === 'lazy') {
    return null;
  }

  const Component = layer.component;

  if (!Component) {
    return (
      <div className="text-muted-foreground flex items-center justify-center p-8">
        Agenda &quot;{layer.agendaId}&quot; nemá přiřazenou komponentu.
      </div>
    );
  }

  return (
    <div
      className={cn('h-full', !isInteractive && 'pointer-events-none opacity-50')}
      aria-hidden={!isInteractive}
    >
      <Component layerId={layer.layerId} />
    </div>
  );
}
